import { put, call } from "redux-saga/effects";
import { arrayToEntityMap } from "lib/data";

import { sendSchoolMoneyDataRequest } from "state/fetchSagas";
import { getSchoolMoneyLocalStoreData, saveSchoolMoneyLocalStoreData } from "state/localStore";
import { fetchStudentsSucceeded } from "state/school_money/actions";

import Student from "state/school_money/entities/Student";

export default function* fetchStudentsSaga(action) {
  const forceApiRefresh = action.payload.forceApiRefresh;
  let studentData;

  if(!forceApiRefresh){
    studentData = getSchoolMoneyLocalStoreData("student");
  }

  if(studentData === undefined){
    const response = yield call(sendSchoolMoneyDataRequest, "get_students");
    studentData = response.data.students;
    saveSchoolMoneyLocalStoreData("student", studentData);
  }

  const studentsByID = arrayToEntityMap(Student.fromAppserver, student => student.id, studentData);
  yield put(fetchStudentsSucceeded(studentsByID));

}



// WEBPACK FOOTER //
// ./src/state/school_money/sagas/fetchStudentsSaga.js